import request from '@/utils/request'

// 同步客户
export function sync_customer(data){
    return request({
        url: 'sync/customer',
        method: 'get',
        params:data
    })
}


// 同步部门
export function sync_department () {
    return request({
        url: 'sync/syn_department',
        method: 'post'
    })
}

// 同步部门下员工
export function sync_department_member () {
    return request({
        url: 'sync/syn_member',
        method: 'post'
    })
}
